

















































































































































































































































































































































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import ConfirmationBox from "@/components/ConfirmationBox.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import { FilteringModel } from "@/services/filtering";
import BankInView from "@/modules/bankInView/models/BankInView";
import CheckBox from "@/components/CheckBox.vue";
import cashStatementStore from "@/modules/cashStatement/services/store";
import eventBus from "@/services/eventBus";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import store, { BankStatementStore } from "@/modules/bankStatement/services/BankStatementStore";
import MoneyInput from "@/components/MoneyInput.vue";
import PartnerSearch from "../../partner/views/PartnerSearch.vue";
import Partner from "../../partner/models/Partner";
import { t } from "@/plugins/i18n";

interface Data {
  filter: FilteringModel;
  sum: number;
  currSum: number;
  items: BankInView[];
  selectedItems: BankInView[];
  store: BankStatementStore;
  isDiffCurrency: boolean;
  selectedPartner: number;
}

interface Props {
  extraFilter: FilteringModel;
  partnerId: number;
  bankStatemnt: number;
  currency: string;
  inCashPoint: boolean;
  title: string;
  isAmountChangeVisible: boolean;
  isEurBank: boolean;
  fromStatement: boolean;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
  layoutKey: string;
  selectedTotal: number;
  selectedTotalCurrency: string;
}

interface Methods {
  selected(item: BankInView): void;
  showDetails(item: BankInView): void;
  addToSummary(dataItem: BankInView): void;
  setItems(items: BankInView[]): void;
  addItems(): void;
  generatePaymentItems(isOverride: boolean): void;
  amountChanged(item: BankInView): void;
  currAmountChanged(item: BankInView): void;
  statementAmountChanged(item: BankInView): void;
  setSummary(): void;
  partnerSelected(partner: Partner): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ApiSearchPage, CheckBox, ValidationError, MoneyInput, ConfirmationBox, PartnerSearch },

  props: {
    extraFilter: { type: Object as () => FilteringModel },
    bankStatemnt: { type: Number, default: 1 },
    partnerId: { type: Number, default: 1 },
    currency: { type: String, default: "" },
    inCashPoint: { type: Boolean, default: false },
    isAmountChangeVisible: { type: Boolean, default: false },
    isEurBank: { type: Boolean, default: false },
    fromStatement: { type: Boolean, default: false },
    title: {
      type: String,
      default: t("Szamlavalogato"),
    },
  },

  data: () => ({
    filter: new FilteringModel(),
    sum: 0,
    currSum: 0,
    items: [],
    selectedItems: [],
    store,
    isDiffCurrency: false,
    selectedPartner: 1,
  }),

  beforeMount() {
    this.filter = new FilteringModel();
    if (this.$props.extraFilter)
      this.filter = this.filter.fromFilter(this.$props.extraFilter.toObject());

    this.selectedPartner = this.$props.partnerId;
  },

  watch: {
    isDiffCurrency(){
      (this.$refs.apiSearch as any).refreshClick();
    }
  },

  methods: {
    partnerSelected(partner: Partner){
      (this.$refs.apiSearch as any).refreshClick();
    },

    async addItems() {
        await cashStatementStore.loadCashDocItemsByDocumentId(
          cashStatementStore.cashDocument.id
        );

      this.$emit("add-selected-items", this.selectedItems);
    },

    selected(item: BankInView) {
      this.$emit("selected", item);
    },

    showDetails(item: BankInView) {
      item.selected = !item.selected;
    },

    addToSummary(dataItem: BankInView) {
      // A selectedItems-et azonnal, közvetlenül karbantartjuk: a korábbi
      // get-items eventbus kör csak a KÖVETKEZŐ eseménynél vette fel a most
      // kijelölt számlát, így lapozáskor/szűréskor az utolsó kijelölés elveszett.
      if (!dataItem.added) {
        dataItem.added = true;
        if (!this.selectedItems.some(x => x.invNo == dataItem.invNo && x.code == dataItem.code)) {
          this.selectedItems.push(dataItem);
        }
      } else {
        dataItem.added = false;

        const selectedItem = this.selectedItems.find(x => x.invNo == dataItem.invNo && x.code == dataItem.code);
        if (selectedItem) {
          const index = this.selectedItems.indexOf(selectedItem);
          this.selectedItems.splice(index, 1);
        }
      }

      this.setSummary();
    },

    setSummary(){
      let sum = 0;
      let currSum = 0;

      // A selectedItems alapján összegzünk, hogy a más oldalakon kijelölt
      // számlák is beleszámítsanak, ne csak az épp látható oldal.
      this.selectedItems.forEach((x: BankInView) => {
        if (x.added){
          sum += Math.abs(x.total);
          currSum += Math.abs(x.statementTotal);
        }
      });

      if (this.store.bankStatement.currency != "HUF"){
        eventBus.$emit("update-curr-sum", currSum);
      } else {
        eventBus.$emit("update-sum", sum);
      }
    },

    generatePaymentItems(isOverride) {
      this.$emit("generate-payments", {
        selectedItems: this.selectedItems,
        partnerID: this.$props.partnerId,
        isOverrideAmount: isOverride
      });

      // SAKT179: a kijelölést csak akkor ürítjük, ha a generálás ténylegesen elindul.
      // Ha a szülő az "összeg nem egyezik" kérdést teszi fel (isAmountChangeVisible), a kijelölés
      // és az összesítő marad, és a válasz utáni hívásnál ürítünk. Korábban már az első
      // kattintásnál kiürült a kijelölés (setSummary nélkül), így a pipák eltűntek, a gomb
      // inaktív lett, az összesítő viszont a régi értéken állt.
      // A szülő a kérdést az emit kezelőjében szinkron állítja, a prop a következő tickben frissül.
      this.$nextTick(() => {
        if (this.isAmountChangeVisible) return;

        this.selectedItems.forEach(x => x.added = false);
        this.selectedItems = [];
        this.setSummary();
      });
    },

    setItems(items) {
      this.items = items;

      this.items.forEach(x => {
        // SAKT29: a banki számlaválogatásnál megőrizzük a számla bruttó értékét a
        // megjelenítéshez, a szerkeszthető összeg mezők pedig a nyitott részt kapják
        // alapértelmezetten. Pénztári használatnál (inCashPoint) ezt nem bántjuk,
        // mert ott a backend a teljes (total/currTotal) értékre számít.
        // A grid ugyanazokat a tételeket többször is kibocsáthatja (get-items),
        // ezért csak egyszer írjuk felül őket.
        if (!this.$props.inCashPoint && x.grossTotal === undefined) {
          x.grossTotal = x.total;
          x.grossCurrTotal = x.currTotal;
          x.total = x.toPayment;
          x.currTotal = x.currToPayment;
        }

        if (this.isEurBank){
          const currency = store.bankDocument.bankStatementItem.invCurrency;
          if (x.invCurrency != currency) {
            x.statementTotal = Math.round(x.currTotal * x.exchangeRate / store.bankDocument.bankStatementItem.exchangeRate * 100) / 100;
          } else {
            x.statementTotal = x.currTotal;
          }
        } else {
          x.statementTotal = x.total;
        }
      });

      const newSelected = items.filter((x) => x.added);
      newSelected.forEach((element) => {
        if (!this.selectedItems.some(x => x.code == element.code && x.invNo == element.invNo)) {
          this.selectedItems.push(element);
        }
      });

      // Lapozás/szűrés után a frissen letöltött sorokon visszajelöljük a
      // korábban kiválasztott számlákat, és a selectedItems-ben a régi
      // objektumot a megjelenített frissre cseréljük; a felhasználó által
      // szerkesztett összegeket és megjegyzést átvisszük a friss sorra.
      this.selectedItems = this.selectedItems.map((element) => {
        const item = items.find(x => x.invNo == element.invNo && x.code == element.code);
        if (item && item !== element) {
          item.added = true;
          item.total = element.total;
          item.currTotal = element.currTotal;
          item.statementTotal = element.statementTotal;
          item.finalRemark = element.finalRemark;
          return item;
        }
        return element;
      });

      this.setSummary();
    },

    amountChanged(item){
      item.currTotal = Math.round(item.total / item.exchangeRate * 100) / 100;

      if (this.isEurBank) {
        const currency = store.bankDocument.bankStatementItem.invCurrency;
        if (currency != item.invCurrency) {
          item.statementTotal = Math.round(item.currTotal * item.exchangeRate / store.bankDocument.bankStatementItem.exchangeRate * 100) / 100;
          } else {
            item.statementTotal = item.currTotal;
          }
        } else {
          item.statementTotal = item.total;
      }

      this.setSummary();
    },

    currAmountChanged(item){
     item.total = Math.round(item.currTotal * item.exchangeRate * 100) / 100;

     if (this.isEurBank) {
        const currency = store.bankDocument.bankStatementItem.invCurrency;
        if (currency != item.invCurrency) {
          item.statementTotal = Math.round(item.currTotal * item.exchangeRate / store.bankDocument.bankStatementItem.exchangeRate * 100) / 100;
          } else {
            item.statementTotal = item.currTotal;
          }
        } else {
          item.statementTotal = item.total;
      }

     this.setSummary();
    },

    statementAmountChanged(item) {
      if (this.isEurBank) {
        const currency = store.bankDocument.bankStatementItem.invCurrency;
        if (item.invCurrency != currency) {
          item.currTotal = Math.round(item.statementTotal * store.bankDocument.bankStatementItem.exchangeRate / item.exchangeRate * 100) / 100;
          item.total = item.currTotal * item.exchangeRate;
        } else {
          item.currTotal = item.statementTotal;
          item.total = item.currTotal * item.exchangeRate;
        }
      } else {
        item.currTotal = item.statementTotal;
        item.total = item.currTotal;
      }

      this.setSummary();
    }
  },

  computed: {
    columns: function() {
      return [
            {
              cell: "statementDetailsButtonTemplate",
              filterable: false,
            },
            //{ field: "code2", title: "Prefix" },
            /*{ field: "invNo", title: "Számlaszám" },*/
            { field: "k2DInvNo", title: t("Szamlaszam") },
            { field: "outerInvNo", title: t("KulsoSzamlaszam") },
            {
              field: "partner",
              title: t("Partner"),
              visible: this.$props.fromStatement,
            },
            {
              cell: "total",
              field: "total",
              title: t("Osszeg"),
              type: ColumnType.Money,
              filterable: false
            },
            {
              cell: "currTotal",
              field: "currTotal",
              title: t("BankExtract_OsszegDev"),
              type: ColumnType.Money,
              filterable: false
            },
            {
              cell: "statementTotal",
              field: "statementTotal",
              title: t("BankExtract_OsszegBank"),
              type: ColumnType.Money,
              filterable: false
            },
            this.$props.inCashPoint
              ? {
                  cell: "toPayment",
                  field: "toPayment",
                  title: t("SzlaNyitottResz"),
                  type: ColumnType.Money,
                }
              : {
                  cell: "grossTotal",
                  field: "grossTotal",
                  title: t("BankExtract_SzamlaBrutto"),
                  type: ColumnType.Money,
                  filterable: false,
                  sortable: false,
                },
            this.$props.inCashPoint
              ? {
                  cell: "currToPayment",
                  field: "currToPayment",
                  title: t("BankExtract_SzlaNyitottReszDev"),
                  type: ColumnType.Money,
                }
              : {
                  cell: "grossCurrTotal",
                  field: "grossCurrTotal",
                  title: t("BankExtract_SzamlaBruttoDev"),
                  type: ColumnType.Money,
                  filterable: false,
                  sortable: false,
                },
            { field: "invCurrency", title: t("Penznem") },
            { field: "bodyNo", title: t("Alvazszam") },
            { field: "invDate", title: t("SzamlaKelte"), type: ColumnType.Date, range: true, headerClass: "date-min-width", fieldClass: "date-min-width" },
            { field: "shipDate", title: t("TeljesitesDatuma"), type: ColumnType.Date, range: true, headerClass: "date-min-width", fieldClass: "date-min-width" },
            { field: "remark1", title: t("Megjegyzes") },
            { field: "finalRemark", title: t("VegszamlaMegjegyzes"), cell: 'finalRemark', filterable: false, sortable: false },
            {
              cell: "selectButton",
              filterable: false,
            },
          ];
    },

    url() {
      return `bankin/dto/search/${this.selectedPartner}/${this.$props.currency}/${this.$props.bankStatemnt}/${this.isDiffCurrency}`;
    },

    // A BankOutView-val azonos oszlopok, ezért közös elrendezés-profilok; a "Bizonylat rögzítése számlából"
    // dialógban más az oszlopkészlet (Partner), ezért ott külön.
    layoutKey() {
      return this.$props.fromStatement ? "BANK_INVOICE_SELECTOR_DOC" : "BANK_INVOICE_SELECTOR";
    },

    // A beválogatott számlák összege a "Bizonylat rögzítése számlából" dialóghoz.
    // A setSummary() logikáját követjük: deviza kivonatnál a banki összeget
    // (statementTotal), HUF-nál a HUF összeget (total) összegezzük.
    selectedTotal() {
      const useCurr = this.store.bankStatement.currency != "HUF";
      return this.selectedItems.reduce(
        (acc, x) => acc + (x.added ? Math.abs(useCurr ? x.statementTotal : x.total) : 0),
        0
      );
    },

    selectedTotalCurrency() {
      return this.store.bankStatement.currency != "HUF"
        ? this.store.bankStatement.currency
        : "HUF";
    },
  },
});
